import { Component, OnInit } from '@angular/core';
import { DbService } from '../service/db-service.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'ceeyu-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  rolefound = false;
  message="Please Wait ....";
  constructor(private router:Router, private dbService: DbService) { }

  ngOnInit(): void {
      firstValueFrom(this.dbService.getAllRoles()).then(
      role => {
        console.log("checking for role...");
        console.log(role);
        if(role.length === 0){
          this.router.navigate(['initlocaldb',{skipLocationChange: true}]);
        }else{
      //    window.location.href = role[0]['forwardurl'];
        }
      },
      error => {
          console.log(error);
      }
    );
  }
}
